$(document).ready(function () {

    adjust_list_articles();

    $(window).resize(function(){
        adjust_list_articles();
    });


    $('.js-share-twitter-link').click(function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        openCenterWindow(href, "Twitter", 550, 285);
    });

    $('.js-share-facebook-link').click(function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        openCenterWindow(href, "Facebook", 550, 475);
    });

    $('.js-share-linkedin-link').click(function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        openCenterWindow(href, "LinkedIn", 550, 475);
    });
});

function adjust_list_articles() {
    var content_height = $('main #content').height();
    var nb_items = Math.ceil(content_height / 350);

    $('main #list-articles .article').hide();
    $('main #list-articles .article').slice(0,nb_items).show();
}

function openCenterWindow(url, title, width, height) {
    var left = (screen.width - width) / 2;
    var top = (screen.height - height) / 2;

    window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width='+width+', height='+height+', top='+top+', left='+left);
}